var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import styled from "styled-components";
import parse from "html-react-parser";
import { getClassName } from "../../../helpers";
import { FIELD_SET, FIELD_SET_TITLE, FIELD_SET_DESCRIPTION } from "../../../classConstants";
import { usePresentationComponent } from "../../../AppContext";
export var FieldSet = function (_a) {
    var className = _a.className, name = _a.name, title = _a.title, _b = _a.description, description = _b === void 0 ? "" : _b, fields = _a.fields;
    var Component = usePresentationComponent("fieldset") || FieldSetComponent;
    var renderTitle = function () {
        return title ? React.createElement(Legend, null,
            React.createElement("h3", { className: FIELD_SET_TITLE }, parse(title))) : null;
    };
    var renderDescription = function () {
        return description ? React.createElement("div", { className: FIELD_SET_DESCRIPTION }, parse(description)) : null;
    };
    return (React.createElement(Component, { className: getClassName(FIELD_SET, className) },
        renderTitle(),
        renderDescription(),
        fields));
};
var FieldSetComponent = styled.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 !important;\n    border: 0 !important;\n    margin: 0 !important;\n"], ["\n    padding: 0 !important;\n    border: 0 !important;\n    margin: 0 !important;\n"])));
var Legend = styled.legend(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 !important;\n    border: 0 !important;\n    margin: 0 !important;\n"], ["\n    padding: 0 !important;\n    border: 0 !important;\n    margin: 0 !important;\n"])));
export var ReactiveFieldSet = function (props) {
    var formOptions = useFormApi();
    return React.createElement(FieldSet, __assign({}, props, { fields: formOptions.renderForm(props.fields, formOptions) }));
};
var templateObject_1, templateObject_2;
